import Vue from 'vue';
import Router from 'vue-router';
import HelloWorld from '@/components/HelloWorld';
import Login from '@/components/Login/Login';
import Dashboard from '@/components/Dashboard';
import ListUser from '@/components/User/ListUser'
import AddUpdateUser from '@/components/User/AddUpdateUser'
import Test from '@/components/Test';
import Sales from '@/components/sales/sales';
import SalesOverview from '@/components/sales/salesoverview';
import postcode from '@/components/postcode/postcode'
import AddUpdatePostcode from '@/components/postcode/AddUpdatePostcode'

Vue.use(Router);

export default new Router({
	mode: 'history',
  	routes: [
		{
            path: '/',
            name: 'Login',
            component: Login
		},
		{
            path: '/dashboard',
            name: 'Dashboard',
            component: Dashboard
        },
        {
            path: '/list-user',
            name: 'ListUser',
            component: ListUser
        },
        {
            path: '/add-user',
            name: 'AddUser',
            component: AddUpdateUser
        },
        {
            path: '/update-user/:id',
            name: 'UpdateUser',
            component: AddUpdateUser
        },
        {
            path: '/test',
            name: 'Test',
            component: Test
        },
        {
            path: '/sales',
            name: 'Sales',
            component: Sales
        },
        {
            path: '/sales/overview',
            name: 'Sales Overview',
            component: SalesOverview
        },
        {
            path: '/postcode',
            name: 'Postcode',
            component: postcode
        },
        {
            path: '/add-postcode',
            name: 'AddPostcode',
            component: AddUpdatePostcode
        },
        {
            path: '/update-postcode/:id',
            name: 'UpdatePostcode',
            component: AddUpdatePostcode
        },
  	]
})



// WEBPACK FOOTER //
// ./src/router/index.js